const JSON_HEADERS = { "Content-Type": "application/json", Accept: "application/json" }

export function validateAdminCredentials({ username, password }) {
  const hasUsername = String(username || "").trim().length > 0
  const hasPassword = String(password || "").trim().length > 0

  return hasUsername && hasPassword ? "" : "请填写管理员账号和密码"
}

export async function createAdminSession(credentials, fetcher = fetch) {
  const response = await fetcher(sameOriginPath("/admin/session"), {
    method: "POST",
    headers: JSON_HEADERS,
    credentials: "same-origin",
    body: JSON.stringify(credentials),
  })
  const payload = await readPayload(response)
  if (!response.ok) throw new Error(payload.error || "登录失败，请稍后再试。")

  return payload.data
}

export async function destroyAdminSession(fetcher = fetch) {
  const response = await fetcher(sameOriginPath("/admin/session"), {
    method: "DELETE",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  })
  if (!response.ok) {
    const payload = await readPayload(response)
    throw new Error(payload.error || "退出登录失败，请稍后再试。")
  }
}

async function readPayload(response) {
  try {
    return await response.json()
  } catch {
    return {}
  }
}

function sameOriginPath(path) {
  if (!globalThis.window) return path
  return new URL(path, window.location.origin).toString()
}
